import { graphql } from 'react-apollo'
import { RESTORE_FILES } from '../../graphql/mutations'

export default graphql(RESTORE_FILES, { name: 'restoreFiles' })
